import useUserContext from 'hooks/user/useUserContext';
import type { TypeUserSegmentationDetailed } from 'types/autogen/contentful';
import ComponentRenderer from '../shared/ComponentRenderer';
import WhenCFPreview from '../shared/WhenCFPreview';

export default function UserSegmentation(props: TypeUserSegmentationDetailed) {
    const {
        fields: { loggedInContent, goldContent, silverContent, plusContent, defaultContent },
        sys: { id }
    } = props;
    const { isAuthenticated, isMatasPlusMember, voyadoMemberLevel } = useUserContext();

    const contentMap = {
        Plus: plusContent,
        Gold: goldContent,
        Silver: silverContent,
        LoggedIn: loggedInContent,
        Default: defaultContent
    };

    const getContent = () => {
        const contentPriority = [
            isMatasPlusMember && contentMap.Plus,
            isMatasPlusMember && contentMap.LoggedIn,
            voyadoMemberLevel === 'Gold' && contentMap.Gold,
            voyadoMemberLevel === 'Gold' && contentMap.LoggedIn,
            voyadoMemberLevel === 'Silver' && contentMap.Silver,
            voyadoMemberLevel === 'Silver' && contentMap.LoggedIn,
            isAuthenticated && contentMap.LoggedIn,
            contentMap.Default
        ];

        return contentPriority.find((content) => content) || contentMap.Default;
    };

    return (
        <WhenCFPreview id={id}>
            <ComponentRenderer {...getContent()} />
        </WhenCFPreview>
    );
}
